export default "__VITE_ASSET__xVsNNUN5__"